import { NumberChartResponse } from '@app/interfaces/report.type';
import React, { FC } from 'react';
type NumberChartPropsType = {
  data: NumberChartResponse;
};
const NumberChart: FC<NumberChartPropsType> = (props) => {
  const { data } = props;
  const trend = data.comparison?.trend;
  const mainTextSizeIsAuto =
    (typeof data.styles?.text_size === 'number' && data.styles.text_size === 0) || false;

  const hasValue =
    data.series?.value !== undefined && data.series?.value !== null && !!data.series?.value;

  const displayValue = hasValue ? data.series.value : null;

  const getTextColor = () => {
    const formatting = data.series?.conditional_formatting?.[0];
    if (formatting?.value && hasValue && typeof displayValue === 'number') {
      if (displayValue >= formatting.value[0] && displayValue <= formatting.value[1]) {
        return formatting.color;
      }
    }
    return data.styles?.text_color;
  };

  const formatNumberWithThousandSeparator = (value: string, isSeparate = true): string => {
    const num = typeof value === 'string' ? parseFloat(value) : value;

    if (!Number.isFinite(num)) {
      return value;
    }

    if (!isSeparate) {
      return String(value);
    }

    // Получаем количество знаков после запятой, чтобы сохранить дробную часть как есть
    const parts = String(value).split('.');
    const minimumFractionDigits = parts[1] ? parts[1].length : 0;

    return new Intl.NumberFormat('ru-RU', {
      useGrouping: true,
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: minimumFractionDigits,
    }).format(num);
  };
  console.log(data);

  return (
    <div
      className={` @container [container-type:size] w-full h-full flex items-center justify-center`}
    >
      <div className="flex items-start gap-[8px]">
        <div
          style={{
            fontSize: mainTextSizeIsAuto
              ? 'clamp(12px, min(100cqw, 100cqh), 500px)'
              : `${data.styles?.text_size}px`,
            color: getTextColor(),
          }}
          className="leading-none"
        >
          {typeof data.series?.value === 'number' ? (
            formatNumberWithThousandSeparator(
              String(data.series?.value),
              data.custom_properties?.numbers_only_separate_thousands,
            )
          ) : (
            <span className="text-[#373d3f] text-[14px] flex ">Нет данных.</span>
          )}
        </div>
        {data.comparison?.enabled && (
          <div className="mt-[5%]">
            <span
              style={{ fontSize: data.styles?.comparison_font_size + 'px' }}
              className="text-3color"
            >
              {trend === 'up' ? '↑ ' : trend === 'down' ? '↓ ' : ''}
            </span>
            <span
              style={{
                color:
                  trend === 'up'
                    ? data.styles?.comparison_positive_color
                    : trend === 'down'
                    ? data.styles.comparison_negative_color
                    : '',
                fontSize: data.styles?.comparison_font_size,
              }}
            >
              {data.comparison?.display_value}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default NumberChart;
